import { Action } from '@ngrx/store';

export const SET_CURRENT_PAGE = '[UX] SET CURRENT PAGE';

export class SetCurrentPage implements Action {
	readonly type = SET_CURRENT_PAGE;
	constructor(public payload: number) {}
}
